import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Dropdown, Form, Grid, Label } from 'semantic-ui-react';
import { paymentActions } from '../../actions/payment.actions';

class PaymentEditScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      client_id: null,
      active: null,
      submitted: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { match, dispatch } = this.props;

    dispatch(paymentActions.getById(match.params.id)).then(() => {
      const { payment } = this.props;

      this.setState({
        name: payment.name,
        active: payment.active,
      });
    });
  }

  handleChange(e, data) {
    if (data) {
      this.setState({ [data.name]: data.value });
    } else {
      const { name, value } = e.target;
      this.setState({ [name]: value });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ submitted: true });
    const { name, active } = this.state;
    const { dispatch, match } = this.props;
    if (name) {
      dispatch(
        paymentActions.update(
          match.params.id,
          {
            name,
            active,
          },
          this.props.history,
        ),
      );
    }
  }

  render() {
    const { name, active, submitted } = this.state;
    const { loading } = this.props;
    let activeOptions;
    activeOptions = [
      { key: 1, value: 1, text: 'Ativo' },
      { key: 2, value: 0, text: 'Inativo' },
    ];

    return (
      <Fragment>
        <Grid className="header-page">
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <h1>Alterar Método de Pagamento</h1>
          </Grid.Column>
        </Grid>

        <Form onSubmit={this.handleSubmit} loading={loading}>
          <Form.Field>
            <label>Nome do Método</label>
            <input
              name="name"
              placeholder="Nome do Método"
              value={name}
              onChange={this.handleChange}
            />
            {submitted && !name && (
              <Label basic color="red" pointing>
                Nome é requerido
              </Label>
            )}
          </Form.Field>
          <Form.Field>
            <label>Status</label>
            <Dropdown
              placeholder="Status"
              fluid
              search
              selection
              name="active"
              options={activeOptions}
              onChange={(event, data) => this.handleChange(true, data)}
              value={active}
            />
          </Form.Field>
          <Button primary payment="submit">
            Atualizar
          </Button>
        </Form>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { payment } = state;
  return {
    payment: payment.item,
    loading: payment.loading || false,
  };
}

const connectedPaymentEditScreen = connect(mapStateToProps)(PaymentEditScreen);
export { connectedPaymentEditScreen as PaymentEditScreen };
